module.exports = __webpack_public_path__ + "img/phone-handle.a5bdc98c.svg";